import { useEffect, useRef } from 'react';

/** `callback`, called `delayMs` after the last call; pending calls are dropped on unmount. */
export function useDebouncedCallback<A extends unknown[]>(
  callback: (...args: A) => void,
  delayMs: number,
) {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const latest = useRef(callback);
  useEffect(() => {
    latest.current = callback;
  }, [callback]);
  useEffect(
    () => () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    },
    [],
  );
  return {
    call(...args: A) {
      if (timer.current) {
        clearTimeout(timer.current);
      }
      timer.current = setTimeout(() => latest.current(...args), delayMs);
    },
    cancel() {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    },
  };
}
